(function () {
  "use strict";

  // Every pm- section renders pm-assets, so this file is included once per section.
  // Run it once, or each bundle gets one click handler per copy and adds to cart that many times.
  if (window.pmSectionsLoaded) return;
  window.pmSectionsLoaded = true;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let bundleInstance = 0;

  const escapeHtml = function (value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  const readNumber = function (value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const money = function (value) {
    return "$" + readNumber(value, 0).toFixed(2);
  };

  const validVariantId = function (value) {
    return /^\d+$/.test(String(value || ""));
  };

  const initCardGallery = function (gallery) {
    const track = gallery.querySelector(".wv-card-track");
    const slides = Array.from(gallery.querySelectorAll(".wv-card-slide"));
    const previous = gallery.querySelector(".wv-card-prev");
    const next = gallery.querySelector(".wv-card-next");
    const dots = Array.from(gallery.querySelectorAll(".wv-card-dot"));
    if (!track || slides.length < 2) return;

    let index = 0;

    const show = function (nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = "translateX(-" + index * 100 + "%)";
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute("aria-hidden", slideIndex === index ? "false" : "true");
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle("wv-active", dotIndex === index);
        if (dotIndex === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    if (previous) {
      previous.addEventListener("click", function () {
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        show(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(readNumber(dot.dataset.slide, 0));
      });
    });

    show(0);
  };

  const initBundle = function (bundle) {
    const dataScript = bundle.querySelector(".wv-bundle-data");
    if (!dataScript) return;

    let products;
    try {
      products = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(products)) return;

    const cardsElement = bundle.querySelector(".wv-cards");
    const linesElement = bundle.querySelector(".wv-summary-lines");
    const totalsElement = bundle.querySelector(".wv-summary-totals");
    const summarySubElement = bundle.querySelector(".wv-summary-sub");
    const nudgeElement = bundle.querySelector(".wv-summary-nudge");
    const subtotalElement = bundle.querySelector(".wv-subtotal");
    const savingRowElement = bundle.querySelector(".wv-saving-row");
    const savingLabelElement = bundle.querySelector(".wv-saving-label");
    const savingsElement = bundle.querySelector(".wv-savings");
    const grandElement = bundle.querySelector(".wv-grand-total");
    const addCartElement = bundle.querySelector(".wv-add-cart");
    const cartMessageElement = bundle.querySelector(".wv-cart-message");
    const filtersElement = bundle.querySelector(".wv-filters");
    const mbar = bundle.querySelector(".wv-mbar");
    const mbarCount = bundle.querySelector(".wv-mbar-count");
    const mbarSub = bundle.querySelector(".wv-mbar-sub");
    const mbarCta = bundle.querySelector(".wv-mbar-cta");

    if (!cardsElement || !linesElement || !totalsElement || !summarySubElement ||
        !nudgeElement || !subtotalElement || !savingRowElement || !savingLabelElement ||
        !savingsElement || !grandElement || !addCartElement || !cartMessageElement) return;

    bundleInstance += 1;
    const instanceId = bundleInstance;
    const tiers = [
      { min: readNumber(bundle.dataset.tier1Min, 0), pct: readNumber(bundle.dataset.tier1Pct, 5), index: 1 },
      { min: readNumber(bundle.dataset.tier2Min, 0), pct: readNumber(bundle.dataset.tier2Pct, 10), index: 2 },
      { min: readNumber(bundle.dataset.tier3Min, 0), pct: readNumber(bundle.dataset.tier3Pct, 15), index: 3 }
    ].filter(function (tier) {
      return tier.min > 0;
    }).sort(function (first, second) {
      return first.min - second.min || first.index - second.index;
    });
    const maxTierPct = tiers.length ? tiers[tiers.length - 1].pct : 0;
    const unitSingular = bundle.dataset.unitSingular || "board";
    const unitPlural = bundle.dataset.unitPlural || "boards";
    const buttonLabel = bundle.dataset.buttonLabel || "Add bundle to cart";
    const emptySub = bundle.dataset.emptySub || "No boards added yet";
    const emptyLine = bundle.dataset.emptyLine || "Add species from the left to start your bundle.";
    const cart = {};
    const selectedVariants = {};
    const selectionTouched = {};
    let addingToCart = false;

    products = products.map(function (product, index) {
      product._index = index;
      if (!Array.isArray(product.variants)) product.variants = [];
      return product;
    });

    products.forEach(function (product, index) {
      const card = cardsElement.querySelector('[data-product-index="' + index + '"]');
      if (!card) return;

      if (product.kind === "maker") {
        const controls = card.querySelector(".wv-maker-controls");
        if (controls) {
          const selectId = "wv-maker-size-" + instanceId + "-" + index;
          const options = product.variants.map(function (variant) {
            return '<option value="' + escapeHtml(variant.id) + '">' +
              escapeHtml(variant.label) + " · " + money(variant.price) + "</option>";
          }).join("");
          controls.innerHTML =
            '<label class="wv-visually-hidden" for="' + selectId + '">Choose a size for ' + escapeHtml(product.title) + "</label>" +
            '<select class="wv-size" id="' + selectId + '" data-product-index="' + index + '"' +
              (product.variants.length ? "" : " disabled") + ">" + options + "</select>" +
            '<div class="wv-card-control">' +
              '<button type="button" class="wv-add-button" data-action="increment">Add to bundle</button>' +
              '<div class="wv-qty" hidden>' +
                '<button type="button" data-action="decrement" aria-label="Decrease quantity">-</button>' +
                '<span class="wv-qty-value">0</span>' +
                '<button type="button" data-action="increment" aria-label="Increase quantity">+</button>' +
              "</div>" +
            "</div>";
        }
      }

      const select = card.querySelector(".wv-size");
      if (select && select.value) selectedVariants[index] = String(select.value);
    });

    const productTitle = function (product) {
      return product.title || product.name || "";
    };

    const selectedVariantFor = function (product) {
      if (product.kind === "lumber") {
        return {
          id: String(product.variantId || ""),
          label: "",
          price: readNumber(product.price, 0)
        };
      }
      if (!product.variants.length) return null;
      const selectedId = String(selectedVariants[product._index] || "");
      let variant = product.variants.find(function (item) {
        return String(item.id) === selectedId;
      });
      if (!variant) variant = product.variants[0];
      selectedVariants[product._index] = String(variant.id);
      return variant;
    };

    const tierFor = function (count) {
      for (let index = tiers.length - 1; index >= 0; index -= 1) {
        if (count >= tiers[index].min) return tiers[index];
      }
      return { pct: 0, index: 0 };
    };

    const nextTier = function (count) {
      const tier = tiers.find(function (item) {
        return count < item.min;
      });
      return tier ? { count: tier.min, pct: tier.pct } : null;
    };

    const updateCard = function (product) {
      const card = cardsElement.querySelector('[data-product-index="' + product._index + '"]');
      if (!card) return;
      const variant = selectedVariantFor(product);
      const variantId = variant ? String(variant.id) : "";
      const quantity = cart[variantId] ? cart[variantId].quantity : 0;
      const addButton = card.querySelector(".wv-add-button");
      const quantityControl = card.querySelector(".wv-qty");
      const quantityValue = card.querySelector(".wv-qty-value");
      const pricePrefix = card.querySelector(".wv-price-prefix");
      const priceValue = card.querySelector(".wv-price-value");

      card.classList.toggle("wv-in-bundle", quantity > 0);
      if (addButton) {
        addButton.hidden = quantity > 0;
        addButton.disabled = !variant || !validVariantId(variantId);
        addButton.dataset.variantId = variantId;
        addButton.dataset.productIndex = product._index;
      }
      if (quantityControl) {
        quantityControl.hidden = quantity <= 0;
        quantityControl.querySelectorAll("button[data-action]").forEach(function (button) {
          button.dataset.variantId = variantId;
          button.dataset.productIndex = product._index;
        });
      }
      if (quantityValue) quantityValue.textContent = quantity;

      if (product.kind !== "lumber" && priceValue) {
        if (selectionTouched[product._index] && variant) {
          priceValue.textContent = money(variant.price);
          if (pricePrefix) pricePrefix.hidden = true;
        } else {
          priceValue.textContent = money(product.fromPrice);
          if (pricePrefix) pricePrefix.hidden = false;
        }
      }
    };

    const updateAllCards = function () {
      products.forEach(updateCard);
    };

    const renderSummary = function () {
      const entries = Object.entries(cart).filter(function (entry) {
        return entry[1].quantity > 0;
      });
      const count = entries.reduce(function (sum, entry) {
        return sum + entry[1].quantity;
      }, 0);
      const subtotal = entries.reduce(function (sum, entry) {
        return sum + entry[1].quantity * entry[1].price;
      }, 0);
      const tier = tierFor(count);
      const saving = subtotal * tier.pct / 100;
      const total = subtotal - saving;

      bundle.querySelectorAll(".wv-step").forEach(function (step) {
        step.classList.toggle("wv-on", Number(step.dataset.tier) === tier.index && count > 0);
      });

      if (!count) {
        linesElement.innerHTML = '<div class="wv-summary-empty">' + escapeHtml(emptyLine) + "</div>";
        totalsElement.hidden = true;
        savingRowElement.hidden = true;
        summarySubElement.textContent = emptySub;
        nudgeElement.textContent = "";
        if (mbar) {
          mbar.dataset.empty = "true";
          if (mbarCount) mbarCount.textContent = "Build your bundle";
          if (mbarSub) mbarSub.textContent = maxTierPct > 0 ? "Mix species and save up to " + maxTierPct + "%" : "Mix and match your species";
          if (mbarCta) mbarCta.textContent = "Build My Bundle";
        }
        return;
      }

      summarySubElement.textContent = count + " " + (count === 1 ? unitSingular : unitPlural);
      linesElement.innerHTML = entries.map(function (entry) {
        const variantId = entry[0];
        const line = entry[1];
        const detail = line.sizeLabel
          ? line.sizeLabel + " · " + line.quantity + " × " + money(line.price)
          : line.quantity + " × " + money(line.price);
        const fullLabel = line.sizeLabel ? line.title + ", " + line.sizeLabel : line.title;
        return '<div class="wv-summary-line">' +
          '<span class="wv-summary-line-name">' + escapeHtml(line.title) + "<small>" + escapeHtml(detail) + "</small></span>" +
          "<span>" + money(line.quantity * line.price) + "</span>" +
          '<button type="button" class="wv-remove-line" data-action="remove" data-variant-id="' + escapeHtml(variantId) +
            '" aria-label="Remove ' + escapeHtml(fullLabel) + '">×</button>' +
        "</div>";
      }).join("");

      totalsElement.hidden = false;
      subtotalElement.textContent = money(subtotal);
      if (saving > 0) {
        savingRowElement.hidden = false;
        savingLabelElement.textContent = "Volume saving (" + tier.pct + "% off)";
        savingsElement.textContent = "-" + money(saving);
      } else {
        savingRowElement.hidden = true;
      }
      grandElement.textContent = money(total);

      const next = nextTier(count);
      if (next) {
        const remaining = next.count - count;
        nudgeElement.textContent = "Add " + remaining + " more " +
          (remaining === 1 ? unitSingular : unitPlural) + " to save " + next.pct + "%";
      } else {
        nudgeElement.textContent = "You have unlocked the best price.";
      }

      if (mbar) {
        mbar.dataset.empty = "false";
        if (mbarCount) mbarCount.textContent = count + " " + (count === 1 ? unitSingular : unitPlural) + (tier.pct > 0 ? " · " + tier.pct + "% off" : "");
        if (mbarSub) mbarSub.textContent = next
          ? "Add " + (next.count - count) + " more to save " + next.pct + "%"
          : "Best price unlocked";
        if (mbarCta) mbarCta.textContent = "Add to cart";
      }
    };

    const addVariant = function (productIndex, variantId) {
      const product = products[productIndex];
      if (!product || !validVariantId(variantId)) return;
      const variant = selectedVariantFor(product);
      if (!variant || String(variant.id) !== String(variantId)) return;

      if (!cart[variantId]) {
        cart[variantId] = {
          quantity: 0,
          title: productTitle(product),
          sizeLabel: variant.label || "",
          price: readNumber(variant.price, 0)
        };
      }
      cart[variantId].quantity += 1;
    };

    cardsElement.addEventListener("click", function (event) {
      const button = event.target.closest("button[data-action]");
      if (!button || !cardsElement.contains(button)) return;
      const variantId = String(button.dataset.variantId || "");
      const productIndex = readNumber(button.dataset.productIndex, -1);

      if (button.dataset.action === "increment") {
        addVariant(productIndex, variantId);
      } else if (button.dataset.action === "decrement" && cart[variantId]) {
        cart[variantId].quantity -= 1;
        if (cart[variantId].quantity <= 0) delete cart[variantId];
      }
      updateAllCards();
      renderSummary();
    });

    cardsElement.addEventListener("change", function (event) {
      const select = event.target.closest("select.wv-size");
      if (!select || !cardsElement.contains(select)) return;
      const productIndex = readNumber(select.dataset.productIndex, -1);
      selectedVariants[productIndex] = String(select.value);
      selectionTouched[productIndex] = true;
      if (products[productIndex]) updateCard(products[productIndex]);
    });

    linesElement.addEventListener("click", function (event) {
      const button = event.target.closest('button[data-action="remove"]');
      if (!button || !linesElement.contains(button)) return;
      delete cart[String(button.dataset.variantId || "")];
      updateAllCards();
      renderSummary();
    });

    if (mbarCta) {
      mbarCta.addEventListener("click", function () {
        if (mbar && mbar.dataset.empty === "false") {
          addCartElement.click();
        } else if (cardsElement) {
          cardsElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }

    if (mbar) {
      const heroSection = document.querySelector(".wv-hero");
      const updateMbarVisibility = function () {
        if (!heroSection) {
          mbar.classList.add("wv-mbar-shown");
          return;
        }
        mbar.classList.toggle("wv-mbar-shown", heroSection.getBoundingClientRect().bottom <= 0);
      };
      updateMbarVisibility();
      window.addEventListener("scroll", updateMbarVisibility, { passive: true });
      window.addEventListener("resize", updateMbarVisibility, { passive: true });
    }

    if (filtersElement) {
      filtersElement.addEventListener("click", function (event) {
        const button = event.target.closest("button[data-category]");
        if (!button || !filtersElement.contains(button)) return;
        const category = button.dataset.category || "All";
        filtersElement.querySelectorAll("button[data-category]").forEach(function (filterButton) {
          filterButton.classList.toggle("wv-active", filterButton === button);
        });
        cardsElement.querySelectorAll(".wv-card").forEach(function (card) {
          card.hidden = category !== "All" && card.dataset.category !== category;
        });
      });
    }

    addCartElement.addEventListener("click", function () {
      if (addingToCart) return;
      const items = Object.entries(cart).filter(function (entry) {
        return entry[1].quantity > 0 && validVariantId(entry[0]);
      }).map(function (entry) {
        return { id: Number(entry[0]), quantity: entry[1].quantity };
      });

      if (!items.length) {
        cartMessageElement.dataset.state = "error";
        cartMessageElement.textContent = "Add at least one " + unitSingular + " to your bundle first.";
        return;
      }

      addingToCart = true;
      addCartElement.disabled = true;
      addCartElement.classList.add("wv-disabled");
      addCartElement.textContent = "Adding...";
      cartMessageElement.textContent = "";
      cartMessageElement.removeAttribute("data-state");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("add failed");
          return response.json();
        })
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          addingToCart = false;
          addCartElement.disabled = false;
          addCartElement.classList.remove("wv-disabled");
          addCartElement.textContent = buttonLabel;
          cartMessageElement.dataset.state = "error";
          cartMessageElement.textContent = "We could not add the bundle. Please try again.";
        });
    });

    bundle.querySelectorAll(".wv-card-gallery").forEach(initCardGallery);
    updateAllCards();
    renderSummary();
  };

  const initReviewCarousel = function (carousel) {
    const viewport = carousel.querySelector(".wv-review-viewport");
    const track = carousel.querySelector(".wv-review-track");
    const slides = Array.from(carousel.querySelectorAll(".wv-review-slide"));
    const previous = carousel.querySelector(".wv-review-prev");
    const next = carousel.querySelector(".wv-review-next");
    const dots = Array.from(carousel.querySelectorAll(".wv-review-dot"));
    if (!viewport || !track || !slides.length) return;

    const autoplayMs = readNumber(carousel.dataset.autoplayMs, 6000);
    let index = 0;
    let timer = null;
    let pointerPaused = false;
    let focusPaused = false;
    let isVisible = true;
    let manualStop = false;

    const visibleCount = function () {
      if (window.innerWidth <= 520) return 1;
      if (window.innerWidth <= 960) return 2;
      return 3;
    };

    const maximumIndex = function () {
      return Math.max(0, slides.length - visibleCount());
    };

    const clearTimer = function () {
      if (timer) window.clearTimeout(timer);
      timer = null;
    };

    const canAutoplay = function () {
      return autoplayMs > 0 && !reducedMotion.matches && !manualStop &&
        !pointerPaused && !focusPaused && isVisible && maximumIndex() > 0;
    };

    const schedule = function () {
      clearTimer();
      if (!canAutoplay()) return;
      timer = window.setTimeout(function () {
        const maximum = maximumIndex();
        index = index >= maximum ? 0 : index + 1;
        update();
        schedule();
      }, autoplayMs);
    };

    const update = function () {
      const maximum = maximumIndex();
      if (index > maximum) index = maximum;
      const offset = slides[index] ? slides[index].offsetLeft : 0;
      track.style.transform = "translateX(-" + offset + "px)";
      dots.forEach(function (dot, dotIndex) {
        const available = dotIndex <= maximum;
        dot.hidden = !available;
        dot.classList.toggle("wv-active", available && dotIndex === index);
        if (available && dotIndex === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const moveManual = function (nextIndex) {
      const maximum = maximumIndex();
      manualStop = true;
      clearTimer();
      if (nextIndex < 0) {
        index = maximum;
      } else if (nextIndex > maximum) {
        index = 0;
      } else {
        index = nextIndex;
      }
      update();
    };

    if (previous) {
      previous.addEventListener("click", function () {
        moveManual(index - 1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        moveManual(index + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        moveManual(readNumber(dot.dataset.slide, 0));
      });
    });

    carousel.addEventListener("mouseenter", function () {
      pointerPaused = true;
      clearTimer();
    });

    carousel.addEventListener("mouseleave", function () {
      pointerPaused = false;
      schedule();
    });

    carousel.addEventListener("focusin", function () {
      focusPaused = true;
      clearTimer();
    });

    carousel.addEventListener("focusout", function (event) {
      if (event.relatedTarget && carousel.contains(event.relatedTarget)) return;
      focusPaused = false;
      schedule();
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(function (entries) {
        isVisible = entries[0] ? entries[0].isIntersecting : true;
        if (isVisible) {
          schedule();
        } else {
          clearTimer();
        }
      }, { threshold: 0.1 });
      observer.observe(carousel);
    }

    window.addEventListener("resize", function () {
      update();
      schedule();
    }, { passive: true });

    if (typeof reducedMotion.addEventListener === "function") {
      reducedMotion.addEventListener("change", schedule);
    }

    update();
    schedule();
  };

  const initLiveReviewCarousel = function (section) {
    const wrapper = section.querySelector(".jdgm-carousel-wrapper");
    if (!wrapper) return;

    const revealWhenReady = function () {
      if (!wrapper.querySelector(".jdgm-carousel-item")) return false;
      section.classList.add("wv-reviews-ready");
      return true;
    };

    if (revealWhenReady()) return;

    const observer = new MutationObserver(function () {
      if (!revealWhenReady()) return;
      observer.disconnect();
    });
    observer.observe(wrapper, { childList: true, subtree: true });
  };

  document.querySelectorAll(".wv-bundle").forEach(initBundle);
  document.querySelectorAll(".wv-review-carousel").forEach(initReviewCarousel);
  document.querySelectorAll(".wv-reviews-live").forEach(initLiveReviewCarousel);
})();
